const moduleState = () => {
  return {
    warningBanners: [],
  }
}
const getters = {
  get: (state) => state.warningBanners,
}

const mutations = {
  setWarningBanners: (state, payload) => {
    if (!payload) {
      state.warningBanners = []

      return
    }

    state.warningBanners = payload
  },
}

const actions = {
  setWarningBanners: ({ commit }, payload) => {
    commit('setWarningBanners', payload)
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
